/* eslint-disable camelcase */

import type { PlanDTO } from '../revenue/plan/types';

export interface CostSpecDTO {
  site_id?: string | number | null;
  plan_id: string;
  always_on_rate: number;
}

export enum ApplicationType {
  'ONCE' = 'ONCE',
  'RECURRING' = 'RECURRING',
}

export interface AppliedDeductionDTO {
  amount: string;
  deduction: {
    id: string;
    name: string;
    application: ApplicationType;
    percentage?: string;
    type?: string;
    amount?: string;
  };
}

export type SalesTaxInfoDTO = {
  vat_rate: number;
  vat_amount: string;
};

export interface LineItemDTO {
  base_cost_per_unit: string;
  cost_per_unit: string;
  subtotal: string;
  total: string;
  units: number;
  deductions: AppliedDeductionDTO[];
  site_plan_info: {
    site_reference: {
      site_id: number;
      name: string;
      organization_id: number;
    };
    plan: PlanDTO;
  };
}

export interface PriceSummaryDTO {
  subtotal: string;
  deductions: AppliedDeductionDTO[];
  tax_info: SalesTaxInfoDTO;
  total: string;
  total_with_tax: string;
  is_prorated: boolean;
  line_items: LineItemDTO[];
}

export interface SubscriptionChangePriceSummaryDTO {
  updated: PriceSummaryDTO;
  future: PriceSummaryDTO;
  charge: PriceSummaryDTO;
  current: PriceSummaryDTO;
}
